const RequestFaqdoc = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {
    console.log('handleFaqDoqQuestion',loginInfo)

    let prompt;
    if (loginInfo?.prompt?.faqdoc?.prompt) {
        prompt = loginInfo.prompt.faqdoc.prompt;
    } else {
        prompt = `あなたは「FAQ1」「FAQ2」の情報を参照して「質問」の要望に答えるRAGアシスタントです。
# ルール
-1. 回答に使用できる情報は「FAQ1」「FAQ2」から「質問」の意図を理解して回答してください。
-2. 必要な情報、通常知識にも存在しない場合、**「×」のみ返す**
-3. 重要な設定値は省略しない。-画像の情報が重要です。URLの画像や動画のリンクがあります。画像や動画を必ず表示させてください。
-4. 参考にした情報はファイル名orサイトのURLのリンクをつけてください。ただしURLがNULLの場合はリンク不要`;
    }

    let filter
    if(loginInfo.faqapi.faqdoc.type==='custom'){ //現在はType:custmしかない
        // HQ/STOREに応じたフィルタ条件を設定
        if(loginInfo.authorityId === 'HQ'){
            filter = [`((status eq 'publish') and (type eq 'user-faq') and (tag eq '${loginInfo.compId}') and (range eq 'HQ_ONLY' or range eq 'ALL_USER'))`,
                `((status eq 'publish') and (bu eq '${loginInfo.compId}')and (filter5 eq 'u_doc') and (filter2 eq 'HQ_ONLY' or filter2 eq 'ALL_USER'))`];
        } else if(loginInfo.authorityId === 'store'){
            filter = [`((status eq 'publish') and (type eq 'user-faq') and (tag eq '${loginInfo.compId}') and (type eq 'user-faq') and (range eq 'STORE_ONLY' or range eq 'ALL_USER'))`,
                `((status eq 'publish') and (bu eq '${loginInfo.compId}')and (filter5 eq 'u_doc') and (filter2 eq 'STORE_ONLY' or filter2 eq 'ALL_USER'))`];
        } else {
            // 店舗・本部以外の人は自分作成分のみ
            filter = [`((status eq 'publish') and (type eq 'user-faq') and (user eq '${loginInfo.userId}'))`,
            `((status eq 'publish') and (filter5 eq 'u_doc') and (user eq '${loginInfo.userId}'))`];
        }
    }
//      "(group eq 'ServicePortal' ) and (category eq 'action')",
//      "(status eq 'publish') and (search.in(type, '026,008,146,115', ','))",
//      "((status eq 'publish') or (status eq null)) and (search.in(bu, '44Oq44OG44Kk44Or5LqL5qWt6YOo', ',') or (search.in(filter3, 'inno', ',')))"


    //    let messages=[]
    let messages=''
    input=input.replace(/<[^>]*>|\[画像情報\]/g, '')

//直近のメッセージボットの2つ取得
    const query = {
        search: input,
        top: 5,
        filter: '',
        select: "sub_category,category,title,content,text,answer,site_name,URL,site_icon,model,update_at,tag",
        vectorQueries: [
            { 
                kind: "text",
                text: input,
                k: 5,
                fields: "embedding"
            }
        ],
    queryType: "semantic",
    captions: "extractive",
    answers: "extractive|count-3",
    semanticConfiguration: "cosmosdb03-semantic-configuration",
    queryLanguage: "ja-JP"
    }

    const header = {
        'Content-Type': 'application/json',
        'api-key': "XXXXXX",
    };

    const requestBody = {
        api:process.env.REACT_APP_FAQ_URL,
        header:header,
        query: query,
        filter:filter,
        userId: userId,
        queryLanguage: "ja-JP",
        mode:mode,
        prompt:prompt,
        inputs:input
    };


//        hist:[inputHists],
//        history:input
    try {
        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        while (true) {
            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                // choices配列が存在し、要素があるかチェック
                if (!dataObj.choices || dataObj.choices.length === 0) {
                    console.warn("choices array is empty or undefined:", dataObj);
                    continue;
                }
                // delta.contentが存在するかチェック
                if (!dataObj.choices[0].delta || !dataObj.choices[0].delta.content) {
                    continue;
                }
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "faqdoc"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "faqdoc", text: delta , mode: 'faqdoc', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage

    } catch (error) {
        console.log('Error',error)
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }

};

// 🔹 他のファイルで使えるようにエクスポート
export default RequestFaqdoc;